import React from "react";

import jmpLogo from "../../assets/images/jmp_logo.svg";
import "./Logo.css";

function easter() {
  console.log(
    `%c
made by:
      ██╗ █████╗ ██████╗ ███████╗██████╗ 
      ██║██╔══██╗██╔══██╗██╔════╝██╔══██╗
      ██║███████║██████╔╝█████╗  ██║  ██║
 ██   ██║██╔══██║██╔══██╗██╔══╝  ██║  ██║
 ╚█████╔╝██║  ██║██║  ██║███████╗██████╔╝
  ╚════╝ ╚═╝  ╚═╝╚═╝  ╚═╝╚══════╝╚═════╝
  ███╗   ███╗   
  ████╗ ████║   
  ██╔████╔██║   
  ██║╚██╔╝██║   
  ██║ ╚═╝ ██║██╗
  ╚═╝     ╚═╝╚═╝  
  ██████╗ ███████╗████████╗███████╗██████╗ ███████╗ ██████╗ ███╗   ██╗
  ██╔══██╗██╔════╝╚══██╔══╝██╔════╝██╔══██╗██╔════╝██╔═══██╗████╗  ██║
  ██████╔╝█████╗     ██║   █████╗  ██████╔╝███████╗██║   ██║██╔██╗ ██║
  ██╔═══╝ ██╔══╝     ██║   ██╔══╝  ██╔══██╗╚════██║██║   ██║██║╚██╗██║
  ██║     ███████╗   ██║   ███████╗██║  ██║███████║╚██████╔╝██║ ╚████║
  ╚═╝     ╚══════╝   ╚═╝   ╚══════╝╚═╝  ╚═╝╚══════╝ ╚═════╝ ╚═╝  ╚═══╝
  `,
    "font-family:monospace"
  );
}

const logo = props => (
  <div className="Logo" onClick={easter}>
    <img src={jmpLogo} alt="JMP" />
  </div>
);

export default logo;



// WEBPACK FOOTER //
// ./src/components/Logo/Logo.js